export const theme = {
  typography: {
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 500,
    color: "var(--secondary-color)",
  },
};
